import dropdown from './dropdown'
import fancybox from './fancybox'
import popover from './popover'
import mcheck from './mcheck'
import maxlength from './maxlength'
import tooltip from './tooltip'

export default Vue => {
  Vue.directive('dropdown', dropdown)
  Vue.directive('fancybox', fancybox)
  Vue.directive('popover', popover)
  Vue.directive('mcheck', mcheck)
  Vue.directive('maxlength', maxlength)
  Vue.directive('tooltip', tooltip)
}
